// extracted by mini-css-extract-plugin
export default {"confirmationText":"ConfirmationPopup_confirmationText__ocia9","confirmationButtons":"ConfirmationPopup_confirmationButtons__kBetu"};